/**
 * BRXCheckoutReturn
 *
 * Renders the checkout-return page and wires its CTAs.
 * Sections: treatment plan (top), what's included, change selection,
 * how it works, reviews carousel, FAQs accordion.
 *
 * Usage:
 *   window.BRXCheckoutReturn.mount(sectionRoot, options);
 */
(function () {

    // -------------------------------------------------------------------------
    // Placeholder data — fill in before launch
    // -------------------------------------------------------------------------

    var REVIEWS = [
        {author: "Drew T.", stars: 5, text: "One month on BraveRX and everything has improved. Libido, erection quality, and just general confidence. Genuinely happy with this product" },
        {author: "Michael", stars: 5, text: "Apomorphine really does enhance things in an incredible way. I thought this was just for erections but it's changed the way I approach my job and the gym too." },
        {author: "Brian", stars: 5, text: "It took a couple days, but I'm definitely getting more erections on this stuff now. Even my wife says it’s bigger." },
        {author: "Patrick", stars: 5, text: "I signed up using my phone, and the entire process took just a few minutes. Within an hour my doctor approved my prescription, perfectly timed for the weekend." },
        // { author: 'John D.', stars: 5, text: 'Lorem ipsum...' }
    ];

    var FAQS = [
        // { question: 'How long does approval take?', answer: '...' }
        {question: "If Viagra or Cialis didn't work for me, will BraveRX?", answer: "BraveRX is built for men who are tired of inconsistent results from old‑school, one‑ingredient pills. By combining a clinically trusted PDE5 inhibitors with a modern arousal‑enhancing formula, BraveRX is designed to deliver stronger, more reliable outcomes than standard Viagra or Cialis alone. Most men who were disappointed with traditional pills choose BraveRX as their next‑level solution."},
        {question: "How long do the effects last?", answer: "Up to 36 hours. Tadalafil — one of BraveRX's active ingredients — is clinically studied to support erectile function for up to 36 hours after dosing, giving you a wide window of spontaneity without re-dosing."},
        {question: "How fast does BraveRX work?", answer: "Fast — typically within 15 minutes or less. The fast-acting sublingual formula is designed for rapid onset, with most men ready in 15–30 minutes."},
        {question: "Where is BraveRX made?", answer: "All BraveRX products are made in the USA by licensed compounding pharmacies. Specifically, BraveRX has partnered with two pharmacies, one in Texas and one in New Jersey. Each medication undergoes regular audits and routine batch testing, and is certified to meet industry-standard accuracy and safety specifications."},
    ];

    var INCLUDED_ITEMS = [
        'Medication, supplies, and instructions',
        'Ongoing clinician support',
        'Free discreet shipping',
        '100% Money-Back Guarantee*',
        'Cancel anytime, come back anytime'
    ];

    var GROUP_IMAGES = {
        'tablets':  'https://cdn.shopify.com/s/files/1/0897/3405/4167/files/checkoutReturn-tablet.webp',
        'capsules': 'https://cdn.shopify.com/s/files/1/0897/3405/4167/files/checkoutReturn-capsule02.webp'
    };

    var PRODUCT_STATS = {
        'surge-max':        92,
        'surge-daily-pro':  91,
        'surge-daily-core': 90,
        'prime-max-pro':    89,
        'prime-max-core':   88,
        'prime-daily-pro':  85,
        'prime-daily-core': 82
    };

    // -------------------------------------------------------------------------
    // Usage chips (treatment plan top section)
    // -------------------------------------------------------------------------

    var usageMap = {
        as_needed: {
            bestForLabel:      'Best for',
            bestForValue:      'In the moment',
            durationLabel:     'Supports you',
            durationValue:     'Up to 36 hours',
            instructionsLabel: 'Take',
            instructionsValue: '15 min before sex'
        },
        daily: {
            bestForLabel:      'Best for',
            bestForValue:      'Always ready',
            durationLabel:     'Supports you',
            durationValue:     '24/7 support',
            instructionsLabel: 'Take',
            instructionsValue: 'Once daily'
        }
    };

    // -------------------------------------------------------------------------
    // Utilities
    // -------------------------------------------------------------------------

    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g,  '&amp;')
            .replace(/</g,  '&lt;')
            .replace(/>/g,  '&gt;')
            .replace(/"/g,  '&quot;')
            .replace(/'/g,  '&#39;');
    }

    function formatMoney(cents) {
        return '$' + ((cents || 0) / 100).toFixed(0);
    }

    function calcDiscount(promoData, priceCents) {
        if (!promoData) return 0;
        if (promoData.type === 'dollars') return Math.round(promoData.value * 100);
        if (promoData.type === 'percent') return Math.round(priceCents * (promoData.value / 100));
        return 0;
    }

    // -------------------------------------------------------------------------
    // Catalog helpers
    // -------------------------------------------------------------------------

    function buildAllCatalogProducts(catalog) {
        var verticals = (catalog && catalog.verticals) ? catalog.verticals : [];
        var seen      = {};
        var result    = [];
        for (var vi = 0; vi < verticals.length; vi++) {
            var categories = verticals[vi].categories || [];
            for (var ci = 0; ci < categories.length; ci++) {
                var cat      = categories[ci];
                var products = cat.products || [];
                for (var pi = 0; pi < products.length; pi++) {
                    var p = products[pi];
                    if (!seen[p.handle]) {
                        seen[p.handle] = true;
                        result.push({
                            product:    p,
                            groupKey:   cat.handle || '',
                            groupLabel: cat.label  || cat.handle || ''
                        });
                    }
                }
            }
        }
        return result;
    }

    // -------------------------------------------------------------------------
    // V2 catalog utilities — offer/cadence helpers
    // -------------------------------------------------------------------------

    function findOfferAndCadence(product, cadenceId) {
        if (!product || cadenceId == null) return null;
        var offers = product.offers || [];
        for (var oi = 0; oi < offers.length; oi++) {
            var cadences = offers[oi].cadences || [];
            for (var ci = 0; ci < cadences.length; ci++) {
                if (String(cadences[ci].id) === String(cadenceId)) {
                    return { offer: offers[oi], cadence: cadences[ci] };
                }
            }
        }
        return null;
    }

    function getDefaultCadence(product) {
        var offers = (product && product.offers) ? product.offers : [];
        for (var oi = 0; oi < offers.length; oi++) {
            var cadences = offers[oi].cadences || [];
            for (var ci = 0; ci < cadences.length; ci++) {
                if (cadences[ci].supplyDays === 90) return cadences[ci];
            }
        }
        return (offers[0] && offers[0].cadences && offers[0].cadences[0]) ? offers[0].cadences[0] : null;
    }

    function findFormulationSiblings(product, catalog) {
        if (!product || !product.collection) return null;
        var siblings  = [];
        var verticals = (catalog && catalog.verticals) ? catalog.verticals : [];
        for (var vi = 0; vi < verticals.length; vi++) {
            var categories = verticals[vi].categories || [];
            for (var ci = 0; ci < categories.length; ci++) {
                var products = categories[ci].products || [];
                for (var pi = 0; pi < products.length; pi++) {
                    if (products[pi].collection === product.collection) {
                        siblings.push(products[pi]);
                    }
                }
            }
        }
        return siblings.length > 1 ? siblings : null;
    }

    function findCadenceBySupplyDays(offer, supplyDays) {
        var cadences = (offer && offer.cadences) ? offer.cadences : [];
        for (var ci = 0; ci < cadences.length; ci++) {
            if (cadences[ci].supplyDays === supplyDays) return cadences[ci];
        }
        return null;
    }

    // -------------------------------------------------------------------------
    // Offer selector, shipping label, cadence selector (V2)
    // -------------------------------------------------------------------------

    function getBestMatchingCadence(targetProduct, activeOffer, activeCadence) {
        var targetDoseCount  = activeOffer   ? activeOffer.doseCount   : null;
        var targetSupplyDays = activeCadence ? activeCadence.supplyDays : 90;
        var offers = targetProduct.offers || [];

        // Same doseCount + same supplyDays
        for (var oi = 0; oi < offers.length; oi++) {
            if (targetDoseCount === null || offers[oi].doseCount === targetDoseCount) {
                var cadences = offers[oi].cadences || [];
                for (var ci = 0; ci < cadences.length; ci++) {
                    if (cadences[ci].supplyDays === targetSupplyDays) return cadences[ci];
                }
            }
        }
        // Any offer with same supplyDays
        for (var oi2 = 0; oi2 < offers.length; oi2++) {
            var cadences2 = offers[oi2].cadences || [];
            for (var ci2 = 0; ci2 < cadences2.length; ci2++) {
                if (cadences2[ci2].supplyDays === targetSupplyDays) return cadences2[ci2];
            }
        }
        return getDefaultCadence(targetProduct);
    }

    function renderOfferSelector(product, activeOffer, activeCadence, catalog, hasCadenceOptions, promoData) {
        if (!product) return '';

        function variantPriceHtml(targetCad, isActive) {
            if (hasCadenceOptions || !targetCad) return '';
            var baseCents     = targetCad.priceCents || 0;
            var discountCents = calcDiscount(promoData, baseCents);
            var isQuarterly   = targetCad.supplyDays === 90;
            var perMonthBase  = isQuarterly ? Math.round(baseCents / 3) : baseCents;
            var savingsHtml   = (isActive && discountCents > 0)
                ? '<div class="embeddables-return__cadence-savings">Save ' + formatMoney(discountCents) + '</div>'
                : '';
            return '<div class="embeddables-return__variant-btn-price">' +
                formatMoney(perMonthBase) + '/mo' +
                savingsHtml +
            '</div>';
        }

        var siblings = findFormulationSiblings(product, catalog);
        if (siblings) {
            var label = 'Select Your Formula';
            var buttons = siblings.map(function (sibling) {
                var isActive    = sibling.handle === product.handle;
                var targetCad   = getBestMatchingCadence(sibling, activeOffer, activeCadence);
                var targetCadId = targetCad ? String(targetCad.id) : '';
                var btnLabel    = sibling.formulationLabel
                    ? escapeHtml(sibling.formulationLabel) + ' Formula'
                    : escapeHtml(sibling.title);
                return '<button type="button"' +
                    ' class="embeddables-return__variant-btn' + (isActive ? ' embeddables-return__variant-btn--active' : '') + '"' +
                    ' data-intake-return-formulation-btn' +
                    ' data-target-cadence-id="' + escapeHtml(targetCadId) + '"' +
                    ' data-product-handle="' + escapeHtml(sibling.handle) + '"' +
                    '>' +
                    '<div class="embeddables-return__variant-btn-left">' +
                        '<span class="embeddables-return__variant-radio' + (isActive ? ' embeddables-return__variant-radio--active' : '') + '"></span>' +
                        '<span class="embeddables-return__variant-btn-title">' + btnLabel + '</span>' +
                    '</div>' +
                    variantPriceHtml(targetCad, isActive) +
                    '</button>';
            }).join('');
            return '<div class="embeddables-return__variant-selector">' +
                '<p class="embeddables-return__variant-selector-label">' + escapeHtml(label) + '</p>' +
                '<div class="embeddables-return__variant-buttons">' + buttons + '</div>' +
            '</div>';
        }

        var offers = product.offers || [];
        if (offers.length <= 1) return '';

        var offerButtons = offers.map(function (offer) {
            var isActive    = activeOffer && offer.doseCount === activeOffer.doseCount;
            var targetCad   = findCadenceBySupplyDays(offer, activeCadence ? activeCadence.supplyDays : 90)
                || getDefaultCadence({ offers: [offer] });
            var targetCadId = targetCad ? String(targetCad.id) : '';
            return '<button type="button"' +
                ' class="embeddables-return__variant-btn' + (isActive ? ' embeddables-return__variant-btn--active' : '') + '"' +
                ' data-intake-return-offer-btn' +
                ' data-offer-dose-count="' + escapeHtml(String(offer.doseCount)) + '"' +
                ' data-target-cadence-id="' + escapeHtml(targetCadId) + '"' +
                '>' +
                '<div class="embeddables-return__variant-btn-left">' +
                    '<span class="embeddables-return__variant-radio' + (isActive ? ' embeddables-return__variant-radio--active' : '') + '"></span>' +
                    '<span class="embeddables-return__variant-btn-title">' + escapeHtml(offer.label) + '</span>' +
                '</div>' +
                variantPriceHtml(targetCad, isActive) +
                '</button>';
        }).join('');

        return '<div class="embeddables-return__variant-selector">' +
            '<p class="embeddables-return__variant-selector-label">Select Your Dose</p>' +
            '<div class="embeddables-return__variant-buttons">' + offerButtons + '</div>' +
        '</div>';
    }

    function renderShippingLabel(cadence) {
        if (!cadence) return '';
        var isQuarterly = cadence.supplyDays === 90;
        var planText = isQuarterly
            ? 'Refills every 3 months'
            : 'Refills every 1 month';
        return '<div class="embeddables-return__cadence-wrapper"><p class="embeddables-return__variant-selector-label">' + escapeHtml(planText) + '</p></div>';
    }

    function renderCadenceSelector(activeOffer, activeCadenceId, promoData) {
        if (!activeOffer) return '';
        var cadences = activeOffer.cadences || [];
        if (cadences.length <= 1) return '';

        // Find monthly cadence for savings calc
        var monthlyCadence = null;
        for (var mi = 0; mi < cadences.length; mi++) {
            if (cadences[mi].supplyDays === 30) { monthlyCadence = cadences[mi]; break; }
        }

        var buttons = cadences.map(function (cadence) {
            var isActive      = activeCadenceId != null && String(cadence.id) === String(activeCadenceId);
            var isQuarterly   = cadence.supplyDays === 90;
            var discount      = calcDiscount(promoData, cadence.priceCents);
            var discounted    = Math.max(0, cadence.priceCents - discount); // used for savings calc only
            var perMonthCents = isQuarterly ? Math.round(cadence.priceCents / 3) : cadence.priceCents;

            var bestValueBadge = (isQuarterly && monthlyCadence)
                ? '<span class="embeddables-return__cadence-best-value">Best value</span>'
                : '';

            var priceHtml;
            if (isQuarterly && monthlyCadence) {
                var savingsCents = monthlyCadence.priceCents * 3 - discounted;
                priceHtml =
                    '<div class="embeddables-return__cadence-price-col">' +
                        '<div class="embeddables-return__cadence-price-row">' +
                            '<s class="embeddables-return__cadence-strike">' + formatMoney(monthlyCadence.priceCents) + '/mo</s>' +
                            '<span class="embeddables-return__cadence-price">' + formatMoney(perMonthCents) + '/mo</span>' +
                        '</div>' +
                        (savingsCents > 0
                            ? '<div class="embeddables-return__cadence-savings">Save ' + formatMoney(savingsCents) + '</div>'
                            : '') +
                    '</div>';
            } else {
                priceHtml =
                    '<div class="embeddables-return__cadence-price-col">' +
                        '<div class="embeddables-return__cadence-price-row">' +
                            '<span class="embeddables-return__cadence-price">' + formatMoney(perMonthCents) + '/mo</span>' +
                        '</div>' +
                    '</div>';
            }

            return '<div class="embeddables-return__cadence-btn-wrap">' +
                bestValueBadge +
                '<button type="button"' +
                ' class="embeddables-return__cadence-btn' + (isActive ? ' embeddables-return__cadence-btn--active' : '') + '"' +
                ' data-intake-return-cadence-btn' +
                ' data-cadence-id="'    + escapeHtml(String(cadence.id))          + '"' +
                ' data-supply-days="'   + escapeHtml(String(cadence.supplyDays))  + '"' +
                ' data-med-id="'        + escapeHtml(cadence.medId || '')         + '"' +
                '>' +
                '<div class="embeddables-return__cadence-btn-left">' +
                    '<span class="embeddables-return__variant-radio' + (isActive ? ' embeddables-return__variant-radio--active' : '') + '"></span>' +
                    '<span class="embeddables-return__cadence-btn-label">' + escapeHtml(cadence.label) + '</span>' +
                '</div>' +
                priceHtml +
                '</button>' +
                '</div>';
        }).join('');

        return '<div class="embeddables-return__cadence-selector">' +
            '<div class="embeddables-return__cadence-buttons">' + buttons + '</div>' +
        '</div>';
    }

    function renderChangeSelection(product, activeOffer, activeCadence, activeCadenceId, promoData, catalog) {
        var cadences = (activeOffer && activeOffer.cadences) ? activeOffer.cadences : [];
        var hasCadenceOptions = cadences.length > 1;
        return renderOfferSelector(product, activeOffer, activeCadence, catalog, hasCadenceOptions, promoData) +
               (hasCadenceOptions ? renderShippingLabel(activeCadence) : '') +
               (hasCadenceOptions ? renderCadenceSelector(activeOffer, activeCadenceId, promoData) : '');
    }

    // -------------------------------------------------------------------------
    // Treatment plan — top section
    // -------------------------------------------------------------------------

    function renderUsageChips(usageType, vertical) {
        var usage = usageMap[usageType];
        if (!usage) return '';

        function chip(label, value) {
            return '<div class="tw-flex tw-justify-center tw-flex-col tw-items-center tw-gap-1 tw-rounded-lg tw-border tw-border-black/10 tw-px-3 tw-py-2 md:tw-py-3 tw-text-center">' +
                '<span class="tw-text-xs md:tw-text-sm tw-leading-none tw-text-charcoal/60 tw-font-medium">'                  + escapeHtml(label) + '</span>' +
                '<span class="tw-text-sm md:tw-text-base tw-font-medium tw-leading-none md:tw-leading-none tw-text-charcoal">' + escapeHtml(value) + '</span>' +
                '</div>';
        }

        var containerClass = vertical ? 'tw-flex tw-flex-col tw-gap-2' : 'tw-grid tw-grid-cols-3 tw-gap-2';

        return '<div class="' + containerClass + '">' +
            chip(usage.bestForLabel,      usage.bestForValue) +
            chip(usage.durationLabel,     usage.durationValue) +
            chip(usage.instructionsLabel, usage.instructionsValue) +
            '</div>';
    }

    function renderAccordionItem(title, contentHtml) {
        if (!contentHtml) return '';

        return '<div class="tw-border-b tw-border-black/10" data-accordion-item>' +
            '<button type="button" class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-4 tw-py-4 tw-text-left" data-accordion-trigger aria-expanded="false">' +
                '<span class="tw-text-base tw-font-medium tw-text-charcoal">' + escapeHtml(title) + '</span>' +
                '<span class="material-symbols-outlined tw-text-[20px] tw-text-charcoal tw-transition-transform tw-duration-200" data-accordion-icon aria-hidden="true">expand_more</span>' +
            '</button>' +
            '<div class="tw-grid tw-grid-rows-[0fr] tw-transition-[grid-template-rows] tw-duration-200 tw-ease-out" data-accordion-panel aria-hidden="true">' +
                '<div class="tw-overflow-hidden">' +
                    '<div class="tw-pb-4 tw-text-sm tw-leading-relaxed tw-text-charcoal/80">' + contentHtml + '</div>' +
                '</div>' +
            '</div>' +
        '</div>';
    }

    function initAccordions(container) {
        var accordions = container.querySelectorAll('[data-brx-return-accordion]');

        accordions.forEach(function (accordion) {
            if (accordion.dataset.initialized === 'true') return;
            accordion.dataset.initialized = 'true';

            var items = accordion.querySelectorAll('[data-accordion-item]');

            function closeItem(item) {
                var trigger = item.querySelector('[data-accordion-trigger]');
                var panel   = item.querySelector('[data-accordion-panel]');
                var icon    = item.querySelector('[data-accordion-icon]');
                if (!trigger || !panel) return;
                trigger.setAttribute('aria-expanded', 'false');
                panel.setAttribute('aria-hidden', 'true');
                panel.classList.remove('tw-grid-rows-[1fr]');
                panel.classList.add('tw-grid-rows-[0fr]');
                if (icon) icon.classList.remove('tw-rotate-180');
            }

            function openItem(item) {
                var trigger = item.querySelector('[data-accordion-trigger]');
                var panel   = item.querySelector('[data-accordion-panel]');
                var icon    = item.querySelector('[data-accordion-icon]');
                if (!trigger || !panel) return;
                trigger.setAttribute('aria-expanded', 'true');
                panel.setAttribute('aria-hidden', 'false');
                panel.classList.remove('tw-grid-rows-[0fr]');
                panel.classList.add('tw-grid-rows-[1fr]');
                if (icon) icon.classList.add('tw-rotate-180');
            }

            items.forEach(function (item) {
                var trigger = item.querySelector('[data-accordion-trigger]');
                if (!trigger) return;
                trigger.addEventListener('click', function () {
                    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
                    items.forEach(function (other) { if (other !== item) closeItem(other); });
                    if (isOpen) closeItem(item); else openItem(item);
                });
            });
        });
    }

    function buildIngredientsHtml(ingredients) {
        if (!ingredients || !ingredients.length) return '';
        return '<ul class="tw-space-y-3 tw-list-none tw-p-0 tw-m-0">' +
            ingredients.map(function (ing) {
                var strengthStr = ing.strength
                    ? ' ' + ing.strength.value + ing.strength.unit
                    : '';
                var label = escapeHtml(ing.name) + escapeHtml(strengthStr);
                return '<li>' +
                    '<span class="tw-font-medium tw-text-charcoal">' + label + '</span>' +
                    (ing.description ? '<p class="tw-mt-0.5 tw-text-charcoal/70 tw-m-0">' + escapeHtml(ing.description) + '</p>' : '') +
                    '</li>';
            }).join('') +
            '</ul>';
    }

    function renderSummary(product) {
        var imageUrl     = escapeHtml((product.images && product.images[0] && product.images[0].url) || '');
        var title        = escapeHtml(product.title        || '');
        var displayTitle = escapeHtml(product.displayTitle || '');
        var usageType    = product.usageType || '';

        var titleDescHtml =
            '<h3 class="tw-normal-case tw-text-charcoal tw-text-xl sm:tw-text-2xl tw-text-left md:tw-text-center">' + title + '</h3>' +
            (displayTitle ? '<div class="tw-mt-1 tw-text-base tw-text-light-charcoal tw-text-left md:tw-text-center">' + displayTitle + '</div>' : '');

        return '<div class="tw-bg-white tw-py-4 md:tw-p-0">' +
            '<h3 class="embeddables-return__section-heading">Your Treatment Plan</h3>' +
            '<div class="tw-flex tw-gap-4 md:tw-items-center">' +
                '<div class="tw-h-[100px] tw-w-[100px] tw-shrink-0 sm:tw-w-[150px] sm:tw-h-[150px] md:tw-h-[240px] md:tw-w-[240px]">' +
                    (imageUrl
                        ? '<img src="' + imageUrl + '" alt="' + title + '" class="tw-h-full tw-w-full tw-rounded-md tw-object-cover" loading="eager" />'
                        : '') +
                '</div>' +
                '<div class="tw-min-w-0 tw-flex-1">' +
                    '<div class="md:tw-hidden">' + titleDescHtml + '</div>' +
                    '<div class="tw-hidden md:tw-block">' + renderUsageChips(usageType, true) + '</div>' +
                '</div>' +
            '</div>' +
            '<div class="tw-hidden md:tw-block tw-mt-4">' + titleDescHtml + '</div>' +
        '</div>';
    }

    function getContentSection(product, key) {
        var sections = product.contentSections || [];
        for (var i = 0; i < sections.length; i++) {
            if (sections[i].key === key) return sections[i].content || '';
        }
        return '';
    }

    function renderDetails(product) {
        var usageType           = product.usageType || '';
        var descriptionHtml     = getContentSection(product, 'description');
        var ingredients         = product.ingredients || [];
        var activeIngredientsHtml = buildIngredientsHtml(ingredients);
        var whatToKnowHtml        = getContentSection(product, 'what_to_know');
        var howToTakeHtml         = getContentSection(product, 'how_to_take');
        var hasAccordion          = activeIngredientsHtml || whatToKnowHtml || howToTakeHtml;
        var statPct               = PRODUCT_STATS[product.handle] != null ? PRODUCT_STATS[product.handle] : 91;

        return '<div class="tw-bg-white tw-pt-2">' +
            '<div class="md:tw-hidden">' + renderUsageChips(usageType) + '</div>' +
            '<div class="tw-mt-4 md:tw-mt-0 tw-text-sm sm:tw-text-base tw-text-light-charcoal tw-text-left md:tw-text-center">' + descriptionHtml + '</div>' +
            '<div class="embeddables-return__stat-card tw-mt-4">' +
                '<span class="embeddables-return__stat-pct">' + statPct + '%</span>' +
                '<span class="embeddables-return__stat-text">of men like you are satisfied with this treatment</span>' +
            '</div>' +
            (hasAccordion
                ? '<div class="tw-mt-4" data-brx-return-accordion>' +
                    renderAccordionItem('Active Ingredients', activeIngredientsHtml) +
                    renderAccordionItem('What to Know',       whatToKnowHtml) +
                    renderAccordionItem('How to Take',        howToTakeHtml) +
                  '</div>'
                : '') +
        '</div>';
    }

    // -------------------------------------------------------------------------
    // What's Included section
    // -------------------------------------------------------------------------

    function checkmarkSvg() {
        return '<svg class="embeddables-return__check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" width="20" height="20">' +
            '<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/>' +
            '</svg>';
    }

    function renderIncluded(product, groupKey) {
        if (!product) return '';
        var title           = escapeHtml(product.title        || '');
        var displayTitle    = escapeHtml(product.displayTitle || '');
        var imageUrl        = (groupKey && GROUP_IMAGES[groupKey]) ? escapeHtml(GROUP_IMAGES[groupKey]) : '';
        var ingredientCount = (product.ingredients && product.ingredients.length) ? product.ingredients.length : 0;

        var badgeHtml = ingredientCount > 0
            ? '<div class="embeddables-return__formula-badge">' + ingredientCount + ' in 1 Formula</div>'
            : '';

        var imageHtml = imageUrl
            ? '<img src="' + imageUrl + '" alt="' + title + '" class="embeddables-return__included-image" loading="lazy">'
            : '<div class="embeddables-return__included-image--placeholder"></div>';

        var itemsHtml = INCLUDED_ITEMS.map(function (item) {
            return '<li class="embeddables-return__included-item">' +
                checkmarkSvg() +
                '<span>' + escapeHtml(item) + '</span>' +
                '</li>';
        }).join('');

        return '<h2 class="embeddables-return__section-heading">What\'s Included?</h2>' +
            '<div class="embeddables-return__included-card tw-p-8">' +
                '<div class="embeddables-return__included-body">' +
                    '<div class="embeddables-return__included-image-wrap">' +
                        imageHtml +
                    '</div>' +
                    '<div class="embeddables-return__included-text">' +
                        badgeHtml +
                        '<p class="tw-text-lg md:tw-text-xl tw-font-medium tw-text-charcoal tw-m-0">' + title + '</p>' +
                        (displayTitle ? '<p class="tw-text-sm md:tw-text-base tw-text-charcoal/70 tw-mt-1 tw-m-0">' + displayTitle + '</p>' : '') +
                    '</div>' +
                '</div>' +
                '<ul class="embeddables-return__included-list">' + itemsHtml + '</ul>' +
            '</div>';
    }

    // -------------------------------------------------------------------------
    // Top-treatments carousel — populate with catalog products
    // -------------------------------------------------------------------------

    function buildCarouselSlideHtml(entry) {
        var p = entry.product;

        var defaultCadence = getDefaultCadence(p);
        var variantId      = defaultCadence ? String(defaultCadence.id) : '';
        var medId          = defaultCadence ? (defaultCadence.medId || '') : '';
        var displayPrice   = defaultCadence ? formatMoney(defaultCadence.priceCents) : '';

        var imageUrl  = (p.images && p.images[0] && p.images[0].url) ? p.images[0].url : '';
        var imageHtml = imageUrl
            ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(p.title) + '" class="embeddables-return__carousel-card-image" loading="lazy">'
            : '<div class="embeddables-return__carousel-card-image embeddables-return__carousel-card-image--placeholder"></div>';

        return '<div class="swiper-slide">' +
            '<button type="button"' +
            ' class="embeddables-return__carousel-card"' +
            ' data-intake-return-select-product' +
            ' data-group-key="'      + escapeHtml(entry.groupKey) + '"' +
            ' data-product-handle="' + escapeHtml(p.handle)       + '"' +
            ' data-variant-id="'     + escapeHtml(variantId)       + '"' +
            ' data-med-id="'         + escapeHtml(medId)           + '"' +
            '>' +
            imageHtml +
            '<span class="embeddables-return__carousel-card-title">' + escapeHtml(p.title) + '</span>' +
            (displayPrice ? '<span class="embeddables-return__carousel-card-price">' + displayPrice + '</span>' : '') +
            '</button>' +
            '</div>';
    }

    function initTopTreatmentsCarousel(returnEl, allProducts) {
        var wrapper = returnEl.querySelector('[data-top-treatments-swiper-wrapper]');
        if (!wrapper || !allProducts || !allProducts.length) return;

        wrapper.innerHTML = allProducts.map(buildCarouselSlideHtml).join('');

        var swiperEl = returnEl.querySelector('.top-treatments-swiper');
        if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.update();
        }
    }

    // -------------------------------------------------------------------------
    // Reviews carousel
    // -------------------------------------------------------------------------

    function renderReviewSlides() {
        if (!REVIEWS || !REVIEWS.length) return '';
        return REVIEWS.map(function (review) {
            var stars = '';
            for (var i = 0; i < 5; i++) {
                stars += '<span class="embeddables-return__star' + (i < review.stars ? ' embeddables-return__star--filled' : '') + '" aria-hidden="true">&#9733;</span>';
            }
            return '<div class="swiper-slide">' +
                '<div class="embeddables-return__review-card">' +
                    '<div class="embeddables-return__review-stars" aria-label="' + escapeHtml(String(review.stars)) + ' out of 5 stars">' + stars + '</div>' +
                    '<p class="embeddables-return__review-text">' + escapeHtml(review.text) + '</p>' +
                    '<p class="embeddables-return__review-author">&mdash; ' + escapeHtml(review.author) + '</p>' +
                '</div>' +
            '</div>';
        }).join('');
    }

    function initReviewsSwiper(returnEl) {
        var wrapper  = returnEl.querySelector('[data-intake-return-reviews-wrapper]');
        var swiperEl = returnEl.querySelector('[data-intake-return-reviews-swiper]');
        if (!wrapper || !swiperEl) return;

        wrapper.innerHTML = renderReviewSlides();
        if (!REVIEWS || !REVIEWS.length) return;
        if (typeof Swiper === 'undefined') return;

        new Swiper(swiperEl, {
            slidesPerView: 1.1,
            spaceBetween: 12,
            navigation: {
                nextEl: returnEl.querySelector('.brx-reviews-swiper-button-next'),
                prevEl: returnEl.querySelector('.brx-reviews-swiper-button-prev')
            },
            breakpoints: {
                480: { slidesPerView: 1.5 },
                640: { slidesPerView: 2, spaceBetween: 16 }
            }
        });
    }

    // -------------------------------------------------------------------------
    // How It Works — IntersectionObserver scroll-fill
    // rootMargin pushes the trigger point up so steps only activate once
    // they've scrolled well into view, not immediately on page load.
    // -------------------------------------------------------------------------

    function initHowItWorksObserver(returnEl) {
        var steps = returnEl.querySelectorAll('[data-intake-return-step]');
        if (!steps.length || typeof IntersectionObserver === 'undefined') return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2, rootMargin: '0px 0px -150px 0px' });

        steps.forEach(function (step) { observer.observe(step); });
    }

    // -------------------------------------------------------------------------
    // FAQs accordion
    // -------------------------------------------------------------------------

    function renderFaqItems() {
        if (!FAQS || !FAQS.length) return '';
        return FAQS.map(function (faq) {
            return renderAccordionItem(faq.question, '<p class="tw-m-0">' + escapeHtml(faq.answer) + '</p>');
        }).join('');
    }

    function initFaqs(returnEl) {
        var faqAccordion = returnEl.querySelector('[data-intake-return-faqs-accordion]');
        if (!faqAccordion) return;
        faqAccordion.innerHTML = renderFaqItems();
        if (FAQS && FAQS.length) {
            initAccordions(returnEl);
        }
    }

    // -------------------------------------------------------------------------
    // Explore More Treatments accordion
    // -------------------------------------------------------------------------

    function initExploreAccordion(returnEl) {
        var toggle = returnEl.querySelector('[data-intake-return-explore-toggle]');
        var panel  = returnEl.querySelector('[data-intake-return-explore-panel]');
        if (!toggle || !panel) return;
        toggle.addEventListener('click', function () {
            var isOpen = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            panel.classList.toggle('is-open', !isOpen);
        });
    }

    // -------------------------------------------------------------------------
    // Mount
    // -------------------------------------------------------------------------

    function mount(root) {
        var returnEl  = root ? root.querySelector('[data-intake-return]')  : null;
        var overlayEl = root ? root.querySelector('[data-intake-overlay]') : null;
        var hostEl    = root ? root.querySelector('[data-intake-host]')    : null;

        if (!returnEl) return;

        // --- Surface visibility ---
        if (overlayEl) { overlayEl.classList.add('is-hidden'); overlayEl.setAttribute('aria-busy', 'false'); }
        if (hostEl)    hostEl.classList.add('is-hidden');
        returnEl.classList.remove('is-hidden');
        root.classList.remove('is-warmup');

        // --- Tear down prior subscription (bfcache remount) ---
        if (returnEl._brxUnsubscribe) {
            returnEl._brxUnsubscribe();
            returnEl._brxUnsubscribe = null;
        }

        // --- Catalog (static for session lifetime) ---
        var catalog = window.BRXSession && window.BRXSession.getCatalog
            ? window.BRXSession.getCatalog()
            : { verticals: [] };
        var allCatalogProducts = buildAllCatalogProducts(catalog);

        // --- One-time static section setup ---
        initHowItWorksObserver(returnEl);
        initReviewsSwiper(returnEl);
        initFaqs(returnEl);
        initTopTreatmentsCarousel(returnEl, allCatalogProducts);
        initExploreAccordion(returnEl);

        // --- Reactive render via BRXSession.subscribe ---
        function renderDynamic() {
            var product = window.BRXSession && window.BRXSession.getSelectionProduct
                ? window.BRXSession.getSelectionProduct()
                : null;
            var sessionState = window.BRXSession && window.BRXSession.getState
                ? window.BRXSession.getState()
                : {};
            var groupKey      = (sessionState.selection && sessionState.selection.groupKey) || null;
            var activeCadenceId = (sessionState.selection && sessionState.selection.variantId) || null;

            // Resolve offer + cadence from session; default to quarterly
            var offerAndCadence = product ? findOfferAndCadence(product, activeCadenceId) : null;
            if (!offerAndCadence && product) {
                var defCad = getDefaultCadence(product);
                if (defCad) {
                    var defOffers = product.offers || [];
                    for (var doi = 0; doi < defOffers.length; doi++) {
                        var defCads = defOffers[doi].cadences || [];
                        for (var dci = 0; dci < defCads.length; dci++) {
                            if (String(defCads[dci].id) === String(defCad.id)) {
                                offerAndCadence = { offer: defOffers[doi], cadence: defCad };
                                break;
                            }
                        }
                        if (offerAndCadence) break;
                    }
                }
            }
            var activeOffer   = offerAndCadence ? offerAndCadence.offer   : null;
            var activeCadence = offerAndCadence ? offerAndCadence.cadence : null;

            var resolvedCheckout = window.BRXSession && window.BRXSession.getResolvedCheckoutUrl
                ? window.BRXSession.getResolvedCheckoutUrl()
                : null;
            var checkoutUrl = resolvedCheckout && resolvedCheckout.url ? resolvedCheckout.url : null;
            var promoCode   = window.BRXSession && window.BRXSession.getPromoCode
                ? window.BRXSession.getPromoCode()
                : null;
            var promoData   = null;
            if (promoCode && window.BRXSession && window.BRXSession.getPromos) {
                var promos = window.BRXSession.getPromos();
                promoData = (promos && promos[promoCode]) ? promos[promoCode] : null;
            }

            // Summary + details
            if (product) {
                var summaryEl = returnEl.querySelector('[data-intake-return-summary]');
                var detailsEl = returnEl.querySelector('[data-intake-return-details]');
                if (summaryEl) summaryEl.innerHTML = renderSummary(product);
                if (detailsEl) {
                    detailsEl.innerHTML = renderDetails(product);
                    initAccordions(detailsEl);
                }
            }

            // Both checkout buttons
            var checkoutBtns = returnEl.querySelectorAll('[data-intake-return-checkout], [data-intake-return-checkout-2]');
            checkoutBtns.forEach(function (btn) {
                if (checkoutUrl) {
                    btn.href = checkoutUrl;
                    btn.removeAttribute('aria-disabled');
                    btn.style.opacity      = '';
                    btn.style.pointerEvents = '';
                } else {
                    btn.setAttribute('aria-disabled', 'true');
                    btn.style.opacity      = '0.6';
                    btn.style.pointerEvents = 'none';
                }
            });

            // What's Included
            var includedEl = returnEl.querySelector('[data-intake-return-included]');
            if (includedEl) includedEl.innerHTML = renderIncluded(product, groupKey);

            // Offer/formulation selector + shipping label + cadence selector
            var variantSelEl = returnEl.querySelector('[data-intake-return-variant-selector]');
            if (variantSelEl) variantSelEl.innerHTML = renderChangeSelection(product, activeOffer, activeCadence, activeCadenceId, promoData, catalog);

        }

        if (window.BRXSession && window.BRXSession.subscribe) {
            var unsubscribe = window.BRXSession.subscribe(function () { renderDynamic(); });
            returnEl._brxUnsubscribe = unsubscribe;
        } else {
            renderDynamic();
        }

        // --- Delegated click handler ---
        if (!returnEl._brxSelectorBound) {
            returnEl._brxSelectorBound = true;
            returnEl.addEventListener('click', function (event) {

                var sess    = window.BRXSession;
                var setSel  = sess && sess.setSelection ? sess.setSelection.bind(sess) : null;
                var getSt   = sess && sess.getState    ? sess.getState.bind(sess)      : function () { return {}; };

                // Formulation toggle (Pro / Core)
                var formulationBtn = event.target.closest('[data-intake-return-formulation-btn]');
                if (formulationBtn) {
                    event.preventDefault();
                    if (!setSel) return;
                    var targetCadId  = formulationBtn.getAttribute('data-target-cadence-id') || null;
                    var targetHandle = formulationBtn.getAttribute('data-product-handle')    || null;
                    var curSel       = getSt().selection || {};
                    setSel({ groupKey: curSel.groupKey || null, productHandle: targetHandle, variantId: targetCadId }, 'return_formulation_selector');
                    return;
                }

                // Offer / dose picker
                var offerBtn = event.target.closest('[data-intake-return-offer-btn]');
                if (offerBtn) {
                    event.preventDefault();
                    if (!setSel) return;
                    var targetCadId2 = offerBtn.getAttribute('data-target-cadence-id') || null;
                    var curSel2      = getSt().selection || {};
                    setSel({ groupKey: curSel2.groupKey || null, productHandle: curSel2.productHandle || null, variantId: targetCadId2 }, 'return_offer_selector');
                    return;
                }

                // Cadence selector (Monthly / 3-Month)
                var cadenceBtn = event.target.closest('[data-intake-return-cadence-btn]');
                if (cadenceBtn) {
                    event.preventDefault();
                    if (!setSel) return;
                    var cadenceId = cadenceBtn.getAttribute('data-cadence-id') || null;
                    var curSel3   = getSt().selection || {};
                    setSel({ groupKey: curSel3.groupKey || null, productHandle: curSel3.productHandle || null, variantId: cadenceId }, 'return_cadence_selector');
                    return;
                }

                // Product cards in the "Explore More Treatments" grid + carousel
                var card = event.target.closest('[data-intake-return-select-product]');
                if (!card) return;
                event.preventDefault();
                var medId = card.getAttribute('data-med-id') || null;
                if (medId && window.BRXSession && window.BRXSession.setSelectionFromMedId) {
                    window.BRXSession.setSelectionFromMedId(medId, 'return_selector');
                } else if (window.BRXSession && window.BRXSession.setSelection) {
                    window.BRXSession.setSelection({
                        groupKey:      card.getAttribute('data-group-key')      || null,
                        productHandle: card.getAttribute('data-product-handle') || null,
                        variantId:     card.getAttribute('data-variant-id')     || null,
                        medId:         medId
                    }, 'return_selector');
                }
            });
        }
    }

    window.BRXCheckoutReturn = { mount: mount };
})();
